import React from 'react'

const Innerwear = () => {
  return (
    <div>Innerwear</div>
  )
}

export default Innerwear